import React from "react";
import { HiMoon, HiSun } from "react-icons/hi";
import { useTheme } from "../../Context/ThemeContext";
import "./ThemeToggle.css";

const LABELS = {
  light: "Light theme",
  dark: "Dark theme",
};

export default function ThemeToggle() {
  const { preference, cyclePreference } = useTheme();

  const Icon = preference === "light" ? HiSun : HiMoon;

  return (
    <button
      type="button"
      className="theme-toggle-btn"
      onClick={cyclePreference}
      title={LABELS[preference]}
      aria-label={LABELS[preference]}
    >
      <Icon />
      <span className="theme-toggle-label">{LABELS[preference]}</span>
    </button>
  );
}
